export default "<mat-card>\n\t<h1>Welcome to Kajimotmomusic!</h1>\n\n\t<p>This is a Progressive Web App built with Angular and Firebase.</p>\n</mat-card>\n";